import { CollapsibleCard, type ToolRendererProps } from '../ToolCard';

/**
 * Fallback for any tool without a dedicated renderer. Shows the raw payload
 * as pretty-printed JSON inside the collapsible. Any future tool that
 * doesn't get a custom card still renders safely through this.
 */
export function GenericToolCard({ toolName, result }: ToolRendererProps) {
  const pretty = (() => {
    try {
      return JSON.stringify(result, null, 2);
    } catch {
      return String(result);
    }
  })();

  return (
    <CollapsibleCard toolName={toolName}>
      <pre className="max-h-64 overflow-auto whitespace-pre-wrap break-words font-mono text-[11px] leading-relaxed text-espresso">
        {pretty}
      </pre>
    </CollapsibleCard>
  );
}
